import { cloneDeep } from "lodash";

export const setSurveyOfferReward = ({ reward, offer }) => {
  reward.offer = offer;

  return cloneDeep(reward);
};

export default setSurveyOfferReward;
